/**
 * Picks the salutation for the current time of day, personalising it when the
 * session already knows who the user is. Shared by the home page and the
 * assistant's empty state, so both greet the same way.
 *
 * The six variants are spelled out with literal keys instead of a composed one
 * so the translation files stay scannable and each language can phrase the
 * whole line freely.
 *
 * @param {function} t_ Translation function.
 * @param {number} hour Local hour of the day, 0-23.
 * @param {string} name User's display name, empty when the session is not resolved yet.
 * @returns {string} The greeting line.
 */
export const resolveGreeting = (t_, hour, name) => {
  if (hour < 12) return name ? t_('Good morning, {{name}}', { name }) : t_('Good morning')
  if (hour < 20) return name ? t_('Good afternoon, {{name}}', { name }) : t_('Good afternoon')
  return name ? t_('Good evening, {{name}}', { name }) : t_('Good evening')
}

/**
 * Display name of the session user. `user` is null while the session is being
 * resolved or after logout, so this degrades to '' rather than assuming a name.
 */
export const sessionDisplayName = (user) => [user?.name, user?.surname].filter((part) => part).join(' ')
